import { HeroSection } from '@/components/landing/HeroSection'
import { ProblemSection } from '@/components/landing/ProblemSection'
import { SolutionSection } from '@/components/landing/SolutionSection'
import { TransformationSection } from '@/components/landing/TransformationSection'
import { AiSection } from '@/components/landing/AiSection'
import { HowItWorksSection } from '@/components/landing/HowItWorksSection'
import { VideoSection } from '@/components/landing/VideoSection'
import { TargetAudienceSection } from '@/components/landing/TargetAudienceSection'
import { BusinessAreasSection } from '@/components/landing/BusinessAreasSection'
import { ProofSection } from '@/components/landing/ProofSection'
import { DifferentiationSection } from '@/components/landing/DifferentiationSection'
import { FaqSection } from '@/components/landing/FaqSection'
import { CtaSection } from '@/components/landing/CtaSection'
import { TestimonialsSection } from '@/components/landing/TestimonialsSection'
import { PartnersSection } from '@/components/landing/PartnersSection'

const Index = () => {
  return (
    <div className="flex flex-col w-full min-h-screen">
      <HeroSection />
      <ProblemSection />
      <SolutionSection />
      <TransformationSection />
      <AiSection />
      <HowItWorksSection />
      <VideoSection />
      <TargetAudienceSection />
      <BusinessAreasSection />
      <ProofSection />
      <PartnersSection />
      <TestimonialsSection />
      <DifferentiationSection />
      <FaqSection />
      <CtaSection />
    </div>
  )
}

export default Index
